export const IsIos = () => {
  return navigator.userAgent.match(/ipad|iphone/i);
};
